module.exports = __webpack_public_path__ + "static/media/alert-cross.9a49613b.svg";